import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { NewProfile } from 'components/Settings/Components/UserProfile/components/newProfile';
import { settingsConfig } from 'components/Settings/settingsConfig';

export const NewProfilePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userManagementNewUser.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.userManagementNewUser.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <NewProfile />
            </MainContent>
        </PageContainer>
    );
};
